import { render, staticRenderFns } from "./ReviewStoryDetail.vue?vue&type=template&id=391aabc4&scoped=true"
import script from "./ReviewStoryDetail.vue?vue&type=script&lang=js"
export * from "./ReviewStoryDetail.vue?vue&type=script&lang=js"
import style0 from "./ReviewStoryDetail.vue?vue&type=style&index=0&id=391aabc4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391aabc4",
  null
  
)

export default component.exports